import { useRef, useEffect, useState } from 'react'
import { useParams, useLocation, useSearchParams } from 'react-router-dom'
import { Helmet } from "react-helmet";
import db from "../../firebase-config"
import HeaderDetail from '../../components/header/HeaderDetail';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import moment from 'moment-timezone';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import Pngegg from '../../assets/img/pngegg.png';
import Shapes from '../../assets/img/shapes.png';
import Selection from "../../assets/img/selection.png";
import Watch from "../../assets/img/watch.png";
import Temperature from "../../assets/img/temperature.png";
import PopupQualityMonitoring from '../../components/model/PopupQualityMonitoring';



const Item = styled(Paper)(({ theme }) => ({
    //backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    //border: '0.8px dashed #c2c2c2',
    borderRadius: "0px 0px 20px 20px",
    //height: { xs: "87%", md: "100%" },

}));

const ItemTotal = styled(Paper)(({ theme }) => ({
    backgroundColor: '#16463e',
    padding: theme.spacing(4),
    textAlign: 'center',
    //border: '0.5px dashed #4A4A49',
    borderRadius: 8,
    // height: '50%',

}));

const ItemDefect = styled(Paper)(({ theme }) => ({
    backgroundColor: '#351f10',
    padding: theme.spacing(3.5),
    textAlign: 'center',
    //border: '0.5px dashed #4A4A49',
    borderRadius: 0,
    // height: '50%',
}));

const ItemCondition = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(0.8),
    textAlign: 'center',
    backgroundColor: '#6e6d6d',
    borderRadius: "10px 10px 0px 0px"
    //height: '102%'

}));


const ItemFryer = styled(Paper)(({ theme }) => ({
    //backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    backgroundColor: '#404040',
    borderRadius: "0px 0px 10px 10px",

}));



const QualityMonitoring = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const today = new Date();
    const hourago = new Date(today.getTime());
    const timestr = moment(hourago).tz('Asia/Bangkok').format('DD MMM YY');
    const time = moment(hourago).tz('Asia/Bangkok').format('HH:mm:ss');

    const [quality_monitoring, setQuality_monitoring] = useState([]);
    const [quality_monitoring_taglist, setQuality_monitoring_taglist] = useState([]);

    useEffect(() => {
        const docIdLine7 = 'Thailand411700000000000000Line7Defect_AI_Inspection';
        const docRefLine7 = db.collection('prod_mes_ignition_defect_dashboard_ai_inspection').doc(docIdLine7);

        const unsubscribeLine7 = docRefLine7.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setQuality_monitoring([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
                //setLoading(true)
                sessionStorage.setItem("QualityLine7", JSON.stringify([{ ...docSnapshot.data(), id: docSnapshot.id }][0]));
            } else {
                console.log('No such document!');
                setQuality_monitoring([]);
            }
        });

        const subscriberQuality = db
            .collection("prod_mes_ignition_defect_dashboard_tag_list")
            .onSnapshot((querySnapshot) => {
                const qualityData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setQuality_monitoring_taglist(qualityData);
                sessionStorage.setItem("QualityTaglistLine7", JSON.stringify(qualityData));
            });
        return () => {
            unsubscribeLine7();
            subscriberQuality();
        }
    }, []);



    const fryerTemp1 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5108.Line7.SP_FryerTemp"));

    const fryerTime1 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5108.Line7.SP_Time"));

    const fryerTempColor1 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5108.Line7.FryerTemperature"));

    const fryerTemp2 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5107.Line7.SP_FryerTemp"));

    const fryerTime2 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5107.Line7.SP_Time"));

    const fryerTempColor2 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5107.Line7.FryerTemperature"));

    const statusConnect = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Simulator.4117.00000000000000.Thailand.AI_Inspection.Cooling.Line7.Connect"));
    
    const fryerColor1 = () => {
        let color;
        try {
            if (fryerTempColor1?.VALUE == undefined ? 0 : fryerTempColor1?.VALUE == fryerTemp1?.VALUE) {
                color = "#2e9281"
            } else if (fryerTempColor1?.VALUE == undefined ? 0 : fryerTempColor1?.VALUE > fryerTemp1?.VALUE) {
                color = "#bd290b"
            } else if ((fryerTempColor1?.VALUE == undefined ? 0 : fryerTempColor1?.VALUE < fryerTemp1?.VALUE)) {
                color = "#0556e3"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const fryerColor2 = () => {
        let color;
        try {
            if (fryerTempColor2?.VALUE == undefined ? 0 : fryerTempColor2?.VALUE == fryerTemp2?.VALUE) {
                color = "#2e9281"
            } else if (fryerTempColor2?.VALUE == undefined ? 0 : fryerTempColor2?.VALUE > fryerTemp2?.VALUE) {
                color = "#bd290b"
            } else if ((fryerTempColor2?.VALUE == undefined ? 0 : fryerTempColor2?.VALUE < fryerTemp2?.VALUE)) {
                color = "#0556e3"
            }
            return color;
        }
        catch {
            console.log()
        }
    }
    return (
        <>
            <Helmet>
                <title>Quality Monitoring  | MES</title>
            </Helmet>
            <Grid container spacing={1} sx={{paddingTop: 2, backgroundColor: colors.neutral['black']}}>
                <Grid item xs={12}>
                    <HeaderDetail
                        line={'Line7'}
                        sku={quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? 'ไม่ตรงแผนผลิต' : quality_monitoring?.SKU}
                        icon={time.toString() >= '06:00:00' && time.toString() <= '18:00:00' ? <LightModeOutlinedIcon style={{ color: '#ffffff', position: "relative", top: '10px' }} /> : <DarkModeOutlinedIcon style={{ color: '#ffffff', position: "relative", top: '10px' }} />}
                    />
                </Grid>
                {statusConnect?.VALUE == undefined ? '' : statusConnect?.VALUE == false ? <PopupQualityMonitoring /> :
                    <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} style={{ paddingTop: 3, paddingLeft: 11, paddingRight: 3 }}>
                        <Grid item xs={8}>
                            <Item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: 'transparent' }}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 20 }}>
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, fontWeight: 'bold', lineHeight: "20px", paddingTop: 10 }} >
                                        Quality Monitoring
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 30 }}>
                                    <ItemTotal >
                                        <Grid item xs={12} textAlign="center" >
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 96, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                    Total&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['green'], fontSize: 96, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.TOTAL_KG).toLocaleString()}&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 64, lineHeight: "20px", paddingTop: 6 }} >
                                                    kg&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 48, lineHeight: "20px", paddingTop: 10 }} >
                                                    (std x pcs)
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </ItemTotal>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }}>
                                    <ItemDefect >
                                        <Grid item xs={12} textAlign="center" >
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 64, lineHeight: "20px", paddingTop: 0 }} >
                                                    Defect&nbsp;&nbsp;
                                                </Typography>
                                                <Typography style={{ color: '#f3ac82', fontSize: 84, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.TOTAL_DEFECT).toLocaleString()}&nbsp;&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 64, lineHeight: "20px", paddingTop: 0 }} >
                                                    kg&nbsp;&nbsp;&nbsp;
                                                </Typography>
                                                <Typography style={{ color: '#f3ac82', fontSize: 84, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : (quality_monitoring?.PERCENT_DEFECT).toLocaleString(undefined, { maximumFractionDigits: 2 })}
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 64, lineHeight: "20px", paddingTop: 0 }} >
                                                    %
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </ItemDefect>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }}>
                                    <Grid container spacing={0.8}>
                                        <Grid item xs={4}>
                                            <ItemDefect >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "-2vh", md: "1vh" } }} textAlign="center" >
                                                    <table style={{ width: '50%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '35%', color: colors.neutral['grey'], fontSize: 20, lineHeight: "10px" }} align="left">
                                                                    <img src={Pngegg} alt="person" style={{ height: '100px', objectFit: 'contain', position: "relative" }} />
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['grey'], fontSize: 64, lineHeight: "10px" }} align="right">
                                                                    Color
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "8vh", md: "4vh" } }} textAlign="center" >
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, lineHeight: "20px", paddingTop: 0 }} >
                                                        {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.REJECT_COLOR).toLocaleString()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "20px", paddingTop: 6 }} >
                                                        kg&nbsp;&nbsp;
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, lineHeight: "20px", paddingTop: 0 }} >
                                                        {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.PERCENT_COLOR).toLocaleString()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                        %
                                                    </Typography>
                                                </Box>
                                            </ItemDefect>
                                        </Grid>

                                        <Grid item xs={4}>
                                            <ItemDefect >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "-2vh", md: "1vh" } }} textAlign="center" >
                                                    <table style={{ width: '50%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 20, lineHeight: "10px" }} align="left">
                                                                    <img src={Shapes} alt="person" style={{ height: '100px', objectFit: 'contain', position: "relative" }} />
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['grey'], fontSize: 64, lineHeight: "10px" }} align="right">
                                                                    Shape
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "4vh", md: "4vh" } }} textAlign="center" >
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, lineHeight: "20px", paddingTop: 0 }} >
                                                        {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.REJECT_SHAPE).toLocaleString()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "20px", paddingTop: 6 }} >
                                                        kg&nbsp;&nbsp;
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, lineHeight: "20px", paddingTop: 0 }} >
                                                        {quality_monitoring?.WARNING == undefined ? '-': quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.PERCENT_SHAPE).toLocaleString()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                        %
                                                    </Typography>
                                                </Box>
                                            </ItemDefect>
                                        </Grid>

                                        <Grid item xs={4}>
                                            <ItemDefect >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "-2vh", md: "1vh" } }} textAlign="center" >
                                                    <table style={{ width: '50%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 20, lineHeight: "10px" }} align="left">
                                                                    <img src={Selection} alt="person" style={{ height: '100px', objectFit: 'contain', position: "relative" }} />
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['grey'], fontSize: 54, lineHeight: "10px" }} align="right">
                                                                    Dimension
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "4vh", md: "4vh" } }} textAlign="center" >
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, lineHeight: "20px", paddingTop: 0 }} >
                                                        {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.REJECT_DIMENSION).toLocaleString()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "20px", paddingTop: 6 }} >
                                                        kg&nbsp;&nbsp;
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 72, lineHeight: "20px", paddingTop: 0 }} >
                                                        {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.floor(quality_monitoring?.PERCENT_DIMENSION).toLocaleString()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "20px", paddingTop: 0 }} >
                                                        %
                                                    </Typography>
                                                </Box>
                                            </ItemDefect>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Grid container spacing={0}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 20 }} >
                                    <ItemCondition>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }} >
                                            <Typography style={{ color: colors.neutral['white'], fontSize: 48, fontWeight: 'bold', lineHeight: "30px", paddingTop: 0 }} >
                                                M/C Condition
                                            </Typography>
                                        </Grid>
                                    </ItemCondition>
                                    <ItemFryer>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 5 }} >
                                            <Grid container spacing={0.8}>
                                                <Grid item xs={5}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 0 }} >
                                                            Fryer
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 40 }} >
                                                            1
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <table style={{ width: '70%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "6vh" }} align="right">
                                                                    <img src={Temperature} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: fryerColor1(), fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTemp1?.VALUE == undefined ? '-' : fryerTemp1?.VALUE}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    ํC
                                                                </td>
                                                            </tr>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "4vh" }} align="right">
                                                                    <img src={Watch} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: '#2e9281', fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTime1?.VALUE == undefined ? '-' : Math.round(fryerTime1?.VALUE / 60)}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    min
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={11} sx={{ borderBottom: "0.5px dashed #c2c2c2", position: "relative", marginLeft: { xs: "2vh", md: "3vh" } }} >

                                        </Grid>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }} >
                                            <Grid container spacing={0.8}>
                                                <Grid item xs={5}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 0 }} >
                                                            Fryer
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 40 }} >
                                                            2
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <table style={{ width: '70%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "4vh" }} align="right">
                                                                    <img src={Temperature} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: fryerColor2(), fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTemp2?.VALUE == undefined ? '-' : fryerTemp2?.VALUE}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    ํC
                                                                </td>
                                                            </tr>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "4vh" }} align="right">
                                                                    <img src={Watch} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: '#2e9281', fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTime2?.VALUE == undefined ? '-' : Math.round(fryerTime2?.VALUE / 60)}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    min
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </ItemFryer>
                                </Grid>

                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 5 }} >
                                    <ItemCondition>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 5 }} >
                                            <Typography style={{ color: colors.neutral['white'], fontSize: 48, fontWeight: 'bold', lineHeight: "30px", paddingTop: 0 }} >
                                                Avg Core Temp
                                            </Typography>
                                        </Grid>
                                    </ItemCondition>
                                    <ItemFryer>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }} >
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "4vh", md: "2vh" } }} textAlign="center" >
                                                <Typography style={{ color: '#2e9281', fontSize: 64, lineHeight: "40px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.AVG_CORE_TEMP}&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "40px", paddingTop: 4 }} >
                                                    ํC&nbsp;&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 64, lineHeight: "40px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.LATEST_AVG_CORE_TEMP}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </ItemFryer>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>}
            </Grid>
        </>
    )
}

export default QualityMonitoring
